<template>
  <div class="i-strengths-and-weaknesses">
    <div v-if="reportStore.hasStrengthItems">
      <iBaseHeader
        highlight-text="Strengths"
        :version="2"
        font-size-highlighted-text="16px"
        text=""
        align="start"
      />
      <iBaseHeader
        highlight-text=""
        text="Your core competencies"
        align="start"
      />

      <iKeywordDetailsSummary
        v-if="!!strengthsSummary && !!strengthItems"
        :data="strengthItems"
        :summary="strengthsSummary"
      />
    </div>
    <div v-if="reportStore.hasWeaknessItems">
      <iBaseHeader
        highlight-text="Weaknesses"
        :version="2"
        font-size-highlighted-text="16px"
        text=""
        align="start"
      />
      <iBaseHeader
        highlight-text=""
        text="Your opportunities for growth"
        align="start"
      />

      <iKeywordDetailsSummary
        v-if="!!weaknessesSummary && !!weaknessItems"
        :data="weaknessItems"
        :summary="weaknessesSummary"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useReportStore } from "@/stores/report"

import iBaseHeader from "@/components/base/BaseHeader.vue"
import iKeywordDetailsSummary from "@/components/report/KeywordDetailsSummary.vue"

// STORES AND COMPOSABLES
const reportStore = useReportStore()

// COMPUTED
const strengthsSummary = computed(() => reportStore.getStrengthSummary)
const strengthItems = computed(() => reportStore.getStrengthItems)

const weaknessesSummary = computed(() => reportStore.getWeaknessSummary)
const weaknessItems = computed(() => reportStore.getWeaknessItems)
</script>

<style scoped lang="scss">
.i-strengths-and-weaknesses {
  @include flex(column, start, stretch, $gap: 56px);
}
</style>
